/**
 * Shared scroll utilities for system status components
 */

export const scrollToElement = (elementId: string): void => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export const createScrollHandler = (elementId: string) => {
  return () => scrollToElement(elementId);
};
